import React, { useState, useContext } from 'react';
import { AppStatusContext } from '../contexts/AppStatusContext';
import './MaintenanceScreen.css';

const MaintenanceScreen = () => {
  const { status, markServerUp } = useContext(AppStatusContext);
  const [retryCount, setRetryCount] = useState(0);
  const [showDetails, setShowDetails] = useState(false);
  const [isRetrying, setIsRetrying] = useState(false);

  if (!status.isDown) return null;

  const handleRetry = async () => {
    setRetryCount(prev => prev + 1);
    setIsRetrying(true);

    try {
      const response = await fetch('/health-check', {
        method: 'GET'
      });

      if (response.ok) {
        markServerUp();
        setIsRetrying(false);
        // Reload page or reset app state
        window.location.reload();
      } else {
        setIsRetrying(false);
      }
    } catch (err) {
      console.error('Health check failed:', err);
      setIsRetrying(false);
    }
  };

  const errorTypeEmoji = {
    'server': '🔧',
    'network': '📡',
    'database': '💾',
    'unknown': '⚠️'
  }[status.errorType] || '⚠️';

  const timeSinceAttempt = status.lastAttempt
    ? Math.round((Date.now() - status.lastAttempt) / 1000)
    : null;

  return (
    <div className="maintenance-overlay">
      <div className="maintenance-container">
        <div className="maintenance-header">
          <div className="maintenance-icon">{errorTypeEmoji}</div>
          <h1>We're Working on It</h1>
        </div>

        <div className="maintenance-message">
          <p>{status.message}</p>

          {timeSinceAttempt && (
            <p className="maintenance-timestamp">
              Last checked: {timeSinceAttempt} seconds ago
            </p>
          )}
        </div>

        <div className="maintenance-details">
          <p>
            🔄 Our team is actively working to resolve this issue.<br/>
            ⏱️ We appreciate your patience during this time.<br/>
            💡 Try refreshing the page or retry below.
          </p>
        </div>

        {showDetails && (
          <div className="maintenance-debug">
            <p><strong>Error Type:</strong> {status.errorType}</p>
            <p><strong>Attempts:</strong> {status.attemptCount}</p>
            <p><strong>Last Attempt:</strong> {status.lastAttempt?.toLocaleTimeString()}</p>
          </div>
        )}

        <div className="maintenance-actions">
          <button
            className="btn-retry"
            onClick={handleRetry}
            disabled={isRetrying}
          >
            {isRetrying ? '🔄 Retrying...' : '🔄 Retry'}
          </button>

          <button
            className="btn-details"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? '✕ Hide Details' : '? More Info'}
          </button>
        </div>

        <div className="maintenance-footer">
          <p className="maintenance-status">
            🟡 Status: Investigating & Recovering
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
